// extracted by mini-css-extract-plugin
module.exports = {"listAction":"BottomMenus_listAction_3NPIq"};